import * as React from 'react';
import Routes from './Routes';
import { Router } from 'react-router';
import { createBrowserHistory } from 'history';
import { QueryParamsProvider } from '../contextProviders/QueryParamsProvider';
import { HistoryContext } from '../contextProviders/HistoryContext';
import * as Amplitude from '@amplitude/analytics-browser';
import { amplitudeKey } from 'src/webportal/utils/constants';

class App extends React.Component {
    componentDidMount() {
        try {
            Amplitude.init(amplitudeKey, { defaultTracking: true });
        } catch (error) {
            console.error(error);
        }
    }

    render() {
        const history = createBrowserHistory(
            { basename: process.env.NODE_ENV === 'production' ? '/webportal' : '' }
        );
        return (
            <QueryParamsProvider history={history}>
                <HistoryContext.Provider value={history}>
                    <Router history={history}>
                        <Routes/>
                    </Router>
                </HistoryContext.Provider>
            </QueryParamsProvider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/webportal/components/root/App.tsx